const validate = (values) => {
    const errors = {};
  
    if (!values.domainName) {
      errors.domainName = 'Please enter domain name';
    }
    return errors;
  };
  export default validate;
  


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/domain/validate.js